import get from 'lodash.get';

import { emptyArray, emptyObject } from '../../default-props/empty';

export const selectScales = (state) => get(state, 'scales', emptyArray);
export const selectDefaultScale = (state) => get(state, 'defaultScale');
export const selectPrinters = (state) => get(state, 'printers', emptyArray);
export const selectPrintJobs = (state) => get(state, 'printJobs', emptyArray);
export const selectWorkstations = (state) => get(state, 'workstations', emptyArray);

export const selectFlattenedPrinters = (state) => {
  const printersGroupedByWorkstation = selectPrinters(state);
  return printersGroupedByWorkstation.flatMap((group) => group.printers);
};

export const selectWorkstationById = (state, { workstationId }) => {
  const workstations = selectWorkstations(state);
  return workstations.find((ws) => ws.workstationId === workstationId) || emptyObject;
};
